"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setup = void 0;
// All configuration for the components module, that should only run one time doing execution, should go into this file.
const setup = () => {
    // basic setup for components module
    // this function is not removed, to keep backwards compatiblity
};
exports.setup = setup;
